import { PermissionGroupName } from 'Services/Api/Roles/Types';

/** API-loaded i18n may lag; these defaults match `en.ts` until backend bundles include the keys. */
export const ROLE_EDIT_I18N_FALLBACK: Partial<Record<string, string>> = {
	'role.editRole.tabs.trainingManager': 'Training Manager',
	'role.editRole.editRolePermissionGroups.trainingManagerManagement':
		'Training Manager'
};

export const PERMISSION_GROUP_HEADING_BY_NAME = {
	[PermissionGroupName.GroupsManagement]:
		'role.editRole.editRolePermissionGroups.groupsManagement',
	[PermissionGroupName.OwnershipGroupsManagement]:
		'role.editRole.editRolePermissionGroups.ownershipGroupsManagement',
	[PermissionGroupName.SystemRolesManagement]:
		'role.editRole.editRolePermissionGroups.systemRolesManagement',
	[PermissionGroupName.UsersManagement]:
		'role.editRole.editRolePermissionGroups.usersManagement',
	[PermissionGroupName.DashboardManagement]:
		'role.editRole.editRolePermissionGroups.dashboardManagement',
	[PermissionGroupName.ReportsManagement]:
		'role.editRole.editRolePermissionGroups.reportsManagement',
	[PermissionGroupName.ForceSyncManagement]:
		'role.editRole.editRolePermissionGroups.forceSyncManagement',
	[PermissionGroupName.SystemsManagement]:
		'role.editRole.editRolePermissionGroups.systemsManagement',
	[PermissionGroupName.MappingManagement]:
		'role.editRole.editRolePermissionGroups.mappingManagement',
	[PermissionGroupName.PhishingManagerManagement]:
		'role.editRole.editRolePermissionGroups.phishingManagerManagement',
	[PermissionGroupName.TrainingManagerManagement]:
		'role.editRole.editRolePermissionGroups.trainingManagerManagement'
};
